import Typography, { TypographyProps } from "@mui/material/Typography";

const ModalTitle = ({ ...props }: TypographyProps) => {
  return (
    <Typography
      variant="h2"
      sx={{ color: "shades.neutral.700", lineHeight: "25px", ...props.sx }}
      {...props}
    >
      {props.children}
    </Typography>
  );
};
export default ModalTitle;
